import { AXIOS_INSTANCE } from '@metaonia/api-client';

import type { UserProfile } from '@metaonia/shared';

let accessToken: string | null = null;
let refreshToken: string | null = null;

export function getDevAccessToken(): string | null {
  return accessToken;
}

export async function devLogin(
  domain: string,
): Promise<{ user: UserProfile; access_token: string; refresh_token: string }> {
  const initResponse = await AXIOS_INSTANCE.post('/auth/sso/init', {
    org_domain: domain,
    redirect_uri: `${window.location.origin}/auth/callback`,
  });

  const callbackResponse = await AXIOS_INSTANCE.post('/auth/sso/callback', {
    code: 'dev-auth-code',
    state: initResponse.data.data.state,
    redirect_uri: `${window.location.origin}/auth/callback`,
  });

  const { access_token, refresh_token: rt, user } = callbackResponse.data.data;
  accessToken = access_token;
  refreshToken = rt;
  sessionStorage.setItem('metaonia_refresh_token', rt);

  return { user, access_token, refresh_token: rt };
}

export async function devRefreshTokens(): Promise<void> {
  const stored = refreshToken ?? sessionStorage.getItem('metaonia_refresh_token');
  if (!stored) throw new Error('No refresh token');

  const response = await AXIOS_INSTANCE.post('/auth/refresh', {
    refresh_token: stored,
  });

  accessToken = response.data.data.access_token;
  refreshToken = response.data.data.refresh_token;
  sessionStorage.setItem('metaonia_refresh_token', response.data.data.refresh_token);
}

export function devLogout(): void {
  accessToken = null;
  refreshToken = null;
  sessionStorage.removeItem('metaonia_refresh_token');
}

export function restoreDevSession(): boolean {
  const stored = sessionStorage.getItem('metaonia_refresh_token');
  if (stored) {
    refreshToken = stored;
    return true;
  }
  return false;
}
